import { render, staticRenderFns } from "./NormalIndex.vue?vue&type=template&id=0a207a00&scoped=true&"
import script from "./NormalIndex.vue?vue&type=script&lang=js&"
export * from "./NormalIndex.vue?vue&type=script&lang=js&"
import style0 from "./NormalIndex.vue?vue&type=style&index=0&id=0a207a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a207a00",
  null
  
)

export default component.exports